<template>
  <v-container
    fluid
    class="fill-height bg"
  >
    <v-row
      justify="center"
      align="center"
      class="fill-height ma-0 v-row__relative"
    >
      <v-btn
        fab
        absolute
        to="/app/processing-list"
        class="back-btn"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-card
        elevation="10"
      >
        <v-card-text>
          <v-container
            fluid
            class="fill-height"
          >
            <v-row
              class="fill-height ma-0"
            >
              <v-flex
                v-if="isLoading"
              >
                <v-progress-circular
                  indeterminate
                  color="info"
                  class="mr-2"
                >
                </v-progress-circular>
                <div class="subtitle-1">Carregando...</div>
              </v-flex>
              <v-flex
                v-else
              >
                <v-alert
                  type="success"
                >
                  Seus email for desinscrito com sucesso.
                </v-alert>
              </v-flex>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
  import {unsubscribeEmail} from "../api/api-messaging"

  export default {
    name: "UnsubscribeEmail",
    data: () => ({
      isLoading: false,
    }),
    methods: {
      onCreated() {
        let unsubData = this.$route.query["unsb"]
        if (!unsubData) {
          this.$router.replace("/login")
          return
        }

        unsubData = atob(unsubData)

        const searchParams = new URLSearchParams(unsubData)
        const email = searchParams.get("email")
        const category = searchParams.get("category")

        if (!email || !category) {
          this.$router.replace("/login")
          return
        }

        unsubscribeEmail(email, category)
          .finally(() => {
            this.isLoading = false
          })
      },
    },
  }
</script>

<style scoped lang="scss">
  .bg {
    background-image: url("../assets/general/bg.jpg");
    background-size: cover;
  }

  .v-row__relative {
    position: relative;
  }

  .back-btn {
    top: 0;
    left: 0;
  }
</style>
